import { User } from 'components/GlobalSearch/types';
import { postApi } from 'utils/Api';

type SearchEmployeesRequest = {
  search_phrase: string;
  type?: 'employee' | 'contractor';
};

type SearchEmployeesResponse = Array<User>;

export const search = {
  searchEmployees: (search_phrase: string, type?: 'employee' | 'contractor') => {
    return postApi<SearchEmployeesResponse, SearchEmployeesRequest>({
      url: `/people/search`,
      requestData: {
        search_phrase,
        ...(type ? { type } : {}),
      },
      responseSchema: {},
    });
  },
};
